import { z } from 'zod'
import { requiredString } from '../../primitives/string'

/**
 * Profesión (catálogo) — fuente única de verdad para la validación del API
 * (nestjs-zod `createZodDto`) y del formulario web (RHF + zodResolver).
 *
 * `isOther` NO forma parte del contrato de escritura: es la fila especial
 * "Otro" que el backend administra (no se crea, no se borra, no se edita
 * por el CRUD admin).
 */

export const CreateProfessionInputSchema = z.object({
  name: requiredString(),
  active: z.boolean().optional()
})

export const UpdateProfessionInputSchema = CreateProfessionInputSchema.partial()

export type CreateProfessionInput = z.infer<typeof CreateProfessionInputSchema>
export type UpdateProfessionInput = z.infer<typeof UpdateProfessionInputSchema>
